"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Gap_1 = tslib_1.__importDefault(require("../Gap"));

var styled_1 = require("./styled");

var DecoratableInput = function DecoratableInput(_a) {
  var suffix = _a.suffix,
      className = _a.className,
      errMsg = _a.errMsg,
      errMsgPosition = _a.errMsgPosition,
      rest = tslib_1.__rest(_a, ["suffix", "className", "errMsg", "errMsgPosition"]);

  return react_1.default.createElement(Gap_1.default, {
    type: "vertical",
    size: "8px"
  }, react_1.default.createElement(styled_1.InputContainer, {
    size: "6px",
    className: className,
    errMsg: errMsg
  }, react_1.default.createElement(styled_1.Input, tslib_1.__assign({}, rest)), suffix && react_1.default.createElement(styled_1.Suffix, null, suffix)), errMsg && react_1.default.createElement(styled_1.ErrorInputMessage, {
    errMsgPosition: errMsgPosition
  }, errMsg));
};

exports.default = DecoratableInput;